<div class="primary-filter-block">
  <div class="filters row d-flex align-items-start">
    <ng-container *ngFor="let item of filterItems">
      <div class="col-md-4 my-2 my-sm-3 text-nowrap">
        <ng-template
          [ngTemplateOutlet]="item.template ? item.template : dropdownTemplate"
          [ngTemplateOutletContext]="{ item: item }"
        ></ng-template>
      </div>
    </ng-container>

    <div
      class="col-sm-3 col-md-4 my-0 my-sm-3"
      *ngIf="showApplyActionBlock"
      [ngClass]="filterItems.length % 2 === 0 ? '' : 'mt-lg-3'"
    >
      <div class="d-flex flex-column gap-1">
        <label
          for="Action"
          class="invisible d-xl-block"
          [ngClass]="filterItems.length % 2 === 0 ? '' : 'd-md-block'"
        >
          Action
        </label>
        <div>
          <button
            class="btn btn-primary col-5 col-sm-5 mx-auto"
            (click)="onClickApply()"
            aria-label="Apply"
            [disabled]="applyDisabled"
          >
            Apply
          </button>
          <button
            class="btn btn-nr-secondary col-5 col-sm-5 ms-2 mx-auto"
            (click)="onClickReset()"
            [disabled]="isResetDisabled"
            aria-label="Reset"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template
  #filterComponentLabelTemplate
  let-filterItem="filterItem"
>
  <label
    class="form-field-label fw-bold"
    for="{{ filterItem.id }}"
    [attr.aria-label]="filterItem.name"
  >
    {{ filterItem.label }}
    <sup
      class="text-danger"
      *ngIf="filterItem.validation?.isRequired"
    >
      *
    </sup>
  </label>
</ng-template>

<ng-template
  #dropdownTemplate
  let-filterItem="item"
>
  <div class="d-flex flex-column gap-1">
    <ng-template
      [ngTemplateOutlet]="filterComponentLabelTemplate"
      [ngTemplateOutletContext]="{ filterItem }"
    ></ng-template>
    <nr-singleselect
      id="{{ filterItem.id }}"
      [config]="filterItem"
      (selectedDataEvent)="onSelectItem($event, filterItem)"
      [ngClass]="{ 'is-invalid': filterItem.validation.isRequired }"
    />
    <span
      class="invalid-feedback text-danger"
      id="{{ filterItem.id }}ErrMsg"
      *ngIf="filterItem.validation.isRequired"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      {{ filterItem.validation?.isRequiredMsg }}
    </span>
  </div>
</ng-template>

<ng-template
  #multiSelectDropdownTemplate
  let-filterItem="item"
>
  <div class="d-flex flex-column gap-1">
    <ng-template
      [ngTemplateOutlet]="filterComponentLabelTemplate"
      [ngTemplateOutletContext]="{ filterItem }"
    ></ng-template>
    <span
      [pTooltip]="getSelectedLabels(filterItem)"
      tooltipPosition="top"
      tooltipStyleClass="custom-tooltip"
      *ngIf="shouldShowTooltip(filterItem)"
    >
      <nr-multiselect
        id="{{ filterItem.id }}"
        [config]="filterItem"
        (selectedDataEvent)="onSelectItem($event, filterItem)"
        [ngClass]="{ 'is-invalid': filterItem.validation.isRequired }"
        #multiSelectComp
      />
    </span>
    <!-- Fallback when tooltip is not needed -->
    <span *ngIf="!shouldShowTooltip(filterItem)">
      <nr-multiselect
        id="{{ filterItem.id }}"
        [config]="filterItem"
        (selectedDataEvent)="onSelectItem($event, filterItem)"
        [ngClass]="{ 'is-invalid': filterItem.validation?.isRequired }"
        #multiSelectComp
      />
    </span>
    <span
      class="invalid-feedback text-danger"
      id="{{ filterItem.id }}ErrMsg"
      *ngIf="
        filterItem.frmControl?.invalid &&
        (filterItem.frmControl?.touched || filterItem.frmControl?.dirty)
      "
    >
      {{ filterItem.validation?.isRequiredMsg }}
    </span>
  </div>
</ng-template>

<ng-template
  #multiSelectTreeDropdownTemplate
  let-filterItem="item"
>
  <div class="d-flex flex-column gap-1">
    <ng-template
      [ngTemplateOutlet]="filterComponentLabelTemplate"
      [ngTemplateOutletContext]="{ filterItem }"
    ></ng-template>
    <nr-treeselect
      id="{{ filterItem.id }}"
      [config]="filterItem"
      (selectedDataEvent)="onSelectItem($event, filterItem)"
      [ngClass]="{ 'is-invalid': filterItem.hasError }"
    />
    <span
      class="invalid-feedback text-danger"
      id="{{ filterItem.id }}ErrMsg"
      *ngIf="
        filterItem.frmControl?.invalid &&
        (filterItem.frmControl?.touched || filterItem.frmControl?.dirty)
      "
    >
      {{ filterItem.validation?.isRequiredMsg }}
    </span>
  </div>
</ng-template>
